import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: ${theme.colors.primary};
    --secondary-color: ${theme.colors.secondary};
    --dark-color: ${theme.colors.sidebarFrom};
    --light-color: ${theme.colors.bg};
    --text-color: ${theme.colors.text};
    --white: #ffffff;
    --gradient: ${theme.colors.accentGradient};
    --box-shadow: ${theme.shadows.md};
    --border-radius: ${theme.radius.lg};
    --card-bg: ${theme.colors.card};
    --shadow: ${theme.shadows.md};
    --radius-md: ${theme.radius.md};
    --transition-base: ${theme.transitions.base};
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.96);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: ${theme.font};
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    background-color: ${theme.colors.bg};
    color: ${theme.colors.text};
    letter-spacing: -0.011em;
    line-height: 1.5;
  }

  #root {
    min-height: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: color ${theme.transitions.fast};
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  :focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
  }

  ::selection {
    background: rgba(255, 107, 107, 0.22);
    color: ${theme.colors.text};
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.35);
    border-radius: ${theme.radius.pill};
    border: 2px solid transparent;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(148, 163, 184, 0.55);
    background-clip: padding-box;
  }

  /* React Toastify — premium styling */
  .Toastify__toast-container {
    padding: 16px;
  }

  .Toastify__toast {
    font-family: ${theme.font};
    border-radius: ${theme.radius.md};
    box-shadow: ${theme.shadows.lg};
    border: 1px solid ${theme.colors.cardBorder};
    padding: 14px 18px;
    min-height: 52px;
    font-size: ${theme.typography.body};
    font-weight: 500;
    color: ${theme.colors.text};
  }

  .Toastify__toast--success {
    background: ${theme.colors.card};
    border-left: 4px solid ${theme.colors.success};
  }

  .Toastify__toast--error {
    background: ${theme.colors.card};
    border-left: 4px solid ${theme.colors.error};
  }

  .Toastify__toast--warning {
    background: ${theme.colors.card};
    border-left: 4px solid ${theme.colors.warning};
  }

  .Toastify__toast--info {
    background: ${theme.colors.card};
    border-left: 4px solid ${theme.colors.primary};
  }

  .Toastify__progress-bar {
    background: ${theme.colors.accentGradient};
    height: 3px;
  }

  .Toastify__close-button {
    color: ${theme.colors.textMuted};
    opacity: 0.7;
  }

  .Toastify__close-button:hover {
    opacity: 1;
    color: ${theme.colors.text};
  }
`;

export default GlobalStyles;
